import { render, staticRenderFns } from "./ACategoriaMoodleEliminar.vue?vue&type=template&id=613868d1"
import script from "./ACategoriaMoodleEliminar.vue?vue&type=script&lang=js"
export * from "./ACategoriaMoodleEliminar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports